import { DepositHistory as Component } from './DepositHistory';
import { withState } from './DepositHistory.state';

export const DepositHistory = withState(Component);
